import React from 'react';
import {formatDate, formatDocumentOrganizationUnit} from "utils/valueFormatter.function.js";
import {Tooltip} from "components/tooltip/Tooltip";

export const SupplierDocumentDetailsDTO = ({details, translate}) => {
    let displayId = details.displayId ? details.displayId : details.documentId;
    return (
        <div>
            {details.description &&
            <div className="document-data-field">
                <div className="document-data-field-label">
                    {translate("documentData.supplierName")}
                </div>
                <div className="document-data-field-value"
                     data-tip="" data-for="description-value-tooltip">
                    {details.description}
                    <Tooltip id="description-value-tooltip" content={() => details.description}/>
                </div>
            </div>}

            <div className="document-data-divided">
                {details.submitterName &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.submitterName")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="" data-for="submitterName-value-tooltip">
                        {details.submitterName}
                        <Tooltip id="submitterName-value-tooltip" content={() => details.submitterName}/>
                    </div>
                </div>}

                {details.createdDate &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.createdDate")}
                    </div>
                    <div className="document-data-field-value">
                        {formatDate(details.createdDate)}
                    </div>
                </div>}

                {details.category &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.category")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="" data-for="category-value-tooltip">
                        {details.category}
                        <Tooltip id="category-value-tooltip" content={() => details.category}/>
                    </div>
                </div>}

                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.documentID")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="" data-for="displayId-value-tooltip">
                        {displayId}
                        <Tooltip id="displayId-value-tooltip" content={() => displayId}/>
                    </div>
                </div>

                {details.corporateData &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.corporateId")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="" data-for="corporateData-value-tooltip">
                        {details.corporateData}
                        <Tooltip id="corporateData-value-tooltip" content={() => details.corporateData}/>
                    </div>
                </div>}

                {details.address &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.address")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="" data-for="address-value-tooltip">
                        {details.address}
                        <Tooltip id="address-value-tooltip" content={() => details.address}/>
                    </div>
                </div>}

                {details.contactInfo &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.phone")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="" data-for="contactInfo-value-tooltip">
                        {details.contactInfo}
                        <Tooltip id="contactInfo-value-tooltip" content={() => details.contactInfo}/>
                    </div>
                </div>}

                {details.gln &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.gln")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="" data-for="gln-value-tooltip">
                        {details.gln}
                        <Tooltip id="gln-value-tooltip" content={() => details.gln}/>
                    </div>
                </div>}

                {details.bankData &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.bankAccount")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="" data-for="bankData-value-tooltip">
                        {details.bankData}
                        <Tooltip id="bankData-value-tooltip" content={() => details.bankData}/>
                    </div>
                </div>}

                {details.termsOfPayments &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.paymentTerms")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="" data-for="termsOfPayments-value-tooltip">
                        {details.termsOfPayments}
                        <Tooltip id="termsOfPayments-value-tooltip" content={() => details.termsOfPayments}/>
                    </div>
                </div>}

                {details.documentOrganizationUnit &&
                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.organizationUnit")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="" data-for="documentOrganizationUnit-value-tooltip">
                        {formatDocumentOrganizationUnit(details.documentOrganizationUnit)}
                        <Tooltip id="documentOrganizationUnit-value-tooltip" content={() => formatDocumentOrganizationUnit(details.documentOrganizationUnit)}/>
                    </div>
                </div>}
            </div>
        </div>
    )
};

export default SupplierDocumentDetailsDTO;

